"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactDraggable = _interopRequireDefault(require("react-draggable")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _ProgressSummary = _interopRequireDefault(require("./ProgressSummary")),
    _UploadItem = _interopRequireDefault(require("./UploadItem")),
    _utils = require("../utils"),
    _constants = require("../../../constants");

require("../styles/_upload-progress.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var UPLOADER_BODY_HEIGHT = 270;

function getToggleIconName(isExpanded, direction) {
  return "DOWN" === direction ? isExpanded ? "arrowup" : "arrowdown" : isExpanded ? "arrowdown" : "arrowup";
}

function getTotalPercent(totalPercentValue) {
  return totalPercentValue ? "".concat(totalPercentValue, "%") : "";
}

function getHeaderTitle(itemsCount, errorCount) {
  var itemsString = "Uploading ".concat(itemsCount, " item").concat(1 < itemsCount ? "s" : ""),
      errorString = errorCount ? " with ".concat(errorCount, " error").concat(1 === errorCount ? "" : "s") : "";
  return itemsString + errorString;
}

var UploadProgress = function (_Component) {
  function UploadProgress(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, UploadProgress), _this = _super.call(this, props), _this.toggleExpand = function () {
      var _this$state = _this.state,
          isExpanded = _this$state.isExpanded,
          blockExpand = _this$state.blockExpand;
      return blockExpand ? void _this.setState({
        dragging: !1,
        blockExpand: !1
      }) : void _this.setState({
        isExpanded: !isExpanded,
        dragging: !1
      });
    }, _this.getLoadedPercent = function (item) {
      var loadedPercent = item.loadedPercent,
          loaded = item.loaded,
          totalSize = item.totalSize;
      return loadedPercent ? loadedPercent : Math.floor(100 * (loaded / totalSize));
    }, _this.renderHeaderProgress = function () {
      var items = _this.props.items,
          isExpanded = _this.state.isExpanded,
          showBytesProgress = 1 === items.length && !isExpanded,
          totalProgressClass = showBytesProgress ? "bytes-progress" : "",
          totalLoadedAll = items.reduce(function (sum, _ref) {
        var loaded = _ref.loaded;
        return sum + loaded || 0;
      }, 0),
          totalSizeAll = items.reduce(function (sum, _ref2) {
        var totalSize = _ref2.totalSize;
        return sum + totalSize || 0;
      }, 0),
          totalProgress = showBytesProgress ? (0, _utils.getUploadProgress)(items[0].loaded, items[0].totalSize) : getTotalPercent(Math.floor(100 * (totalLoadedAll / totalSizeAll)));
      return _react["default"].createElement("span", {
        className: totalProgressClass
      }, totalProgress);
    }, _this.renderHeader = function () {
      var _this$state2 = _this.state,
          isExpanded = _this$state2.isExpanded,
          blockExpand = _this$state2.blockExpand,
          _this$props = _this.props,
          items = _this$props.items,
          direction = _this$props.direction,
          loaded = (0, _utils.getItemUploadedSize)(items[0]),
          errors = items.filter(function (_ref3) {
        var uploadStatus = _ref3.uploadStatus;
        return "error" === uploadStatus;
      });
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("upload-progress__header", {
          "upload-progress__header--collapsed": !isExpanded
        }),
        style: {
          cursor: blockExpand ? "grabbing" : void 0
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: (0, _onEnterPressed["default"])({
          onClick: _this.toggleExpand
        }),
        onClick: _this.toggleExpand
      }, _react["default"].createElement("div", {
        className: "upload-progress__header__info"
      }, _react["default"].createElement("div", {
        className: "upload-progress__header__info__title"
      }, getHeaderTitle(items.length, errors.length)), _react["default"].createElement("div", {
        className: "upload-progress__header__info__percents"
      }, _this.renderHeaderProgress(), _react["default"].createElement(_uiKit.Icon, {
        name: getToggleIconName(isExpanded, direction),
        className: "upload-progress__header__info__percents__toggle",
        color: "white",
        size: 8
      }))), !isExpanded && 1 === items.length && loaded ? _react["default"].createElement(_ProgressSummary["default"], {
        loadedPercent: _this.getLoadedPercent(items[0]),
        loaded: loaded,
        total: items[0].totalSize,
        status: items[0].uploadStatus,
        hideProgressValue: !0
      }) : null);
    }, _this.handleDrag = function () {
      var _this$state3 = _this.state,
          dragging = _this$state3.dragging,
          blockExpand = _this$state3.blockExpand;
      return dragging && blockExpand ? void 0 : dragging ? void _this.setState({
        blockExpand: !0
      }) : void _this.setState({
        dragging: !0
      });
    }, _this.renderItemsList = function () {
      var isExpanded = _this.state.isExpanded,
          _this$props2 = _this.props,
          items = _this$props2.items,
          retry = _this$props2.retry,
          remove = _this$props2.remove,
          hidden = !isExpanded || !items || !items.length;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("upload-progress__body", {
          "upload-progress__body--hidden": hidden
        })
      }, items.map(function (uploadItem) {
        var filename = uploadItem.filename,
            loadedPercent = uploadItem.loadedPercent,
            loaded = uploadItem.loaded,
            uploadStatus = uploadItem.uploadStatus,
            totalSize = uploadItem.totalSize,
            assetId = uploadItem.assetId,
            organisationId = uploadItem.organisationId,
            metaData = uploadItem.metaData;
        return _react["default"].createElement(_UploadItem["default"], {
          key: assetId,
          assetId: assetId,
          filename: filename,
          loadedPercent: loadedPercent,
          loaded: loaded,
          totalSize: totalSize,
          status: uploadStatus,
          retry: retry,
          remove: remove,
          organisationId: organisationId,
          metaData: metaData
        });
      }));
    }, _this.state = {
      isExpanded: !1
    }, _this;
  }

  (0, _inherits2["default"])(UploadProgress, _Component);

  var _super = _createSuper(UploadProgress);

  return (0, _createClass2["default"])(UploadProgress, [{
    key: "render",
    value: function render() {
      var items = this.props.items,
          isExpanded = this.state.isExpanded;
      return items && items.length ? items.every(function (_ref4) {
        var uploadStatus = _ref4.uploadStatus;
        return uploadStatus && uploadStatus === _constants.ITEM_STATUS.SUCCESS;
      }) ? null : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "upload-progress-draggable",
        style: {
          paddingTop: isExpanded ? 0 : UPLOADER_BODY_HEIGHT
        }
      }), _react["default"].createElement(_reactDraggable["default"], {
        bounds: ".upload-progress-draggable",
        onDrag: this.handleDrag,
        handle: ".upload-progress__header"
      }, _react["default"].createElement("div", {
        className: "upload-progress"
      }, this.renderHeader(), this.renderItemsList()))) : null;
    }
  }]), UploadProgress;
}(_react.Component);

exports["default"] = UploadProgress;